// DS1.7.4
import React from 'react';
import classnames from 'classnames';
import s from './EngagementIndicator.scss';

interface Props {
  type: 'comment' | 'fave';
  className?: string;
}

const EngagementIndicator: React.FC<Props> = ({ type, className }) => (
  <div className={classnames(s['root'], className)}>
    {type === 'comment' && (
      <svg
        fill="none"
        height="16"
        width="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipRule="evenodd" fillRule="evenodd">
          <path
            d="m14 0h-10.08579c-.53043 0-1.03914.210714-1.41421.585786l-1.914214 1.914214c-.375073.37507-.585786.88378-.585786 1.41421v7.08579c0 1.1046.895431 2 2 2h2v1c0 1.1046.89543 2 2 2h.46482c.6687 0 1.29317-.3342 1.6641-.8906l1.40626-2.1094h2.55062c.5304 0 1.0391-.2107 1.4142-.5858l1.9142-1.9142c.3751-.3751.5858-.88378.5858-1.41421v-7.08579c0-1.10457-.8954-2-2-2z"
            className={s['outline']}
          />
          <path
            d="m15 2c0-.55228-.4477-1-1-1h-10.08579c-.26521 0-.51957.10536-.7071.29289l-1.91422 1.91422c-.18753.18753-.29289.44189-.29289.7071v7.08579c0 .5523.44772 1 1 1h3v2c0 .5523.44772 1 1 1h.46482c.33435 0 .64658-.1671.83205-.4453l1.70313-2.5547h3.0858c.2652 0 .5196-.1054.7071-.2929l1.9142-1.91421c.1875-.18753.2929-.44189.2929-.7071z"
            className={s['filled']}
          />
        </g>
      </svg>
    )}
    {type === 'fave' && (
      <svg
        fill="none"
        height="16"
        width="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m5.86723.987619-1.22455 2.336161-2.78347.42363c-.67247.10234-1.235069.62363-1.451804 1.3452l-.3138429 1.04485c-.2264751.75399-.033762 1.5869.4909889 2.12206l1.903048 1.94078-.44121 2.7054c-.12827.7865.1726 1.5833.7654 2.027l.95822.7172c.5294.3962 1.20676.4463 1.77792.1314l2.45774-1.3548 2.51523 1.3719c.5748.3135 1.2552.2584 1.7839-.1447l.9279-.7074c.5886-.4487.8834-1.2468.7505-2.0311l-.4606-2.7179 1.8928-1.93044c.5321-.5426.7221-1.39034.4822-2.1508l-.3248-1.02931c-.2232-.70747-.7801-1.21559-1.4429-1.31646l-2.7915-.42485-1.2275-2.35391c-.32022-.614109-.90675-.99153-1.54087-.99153h-1.16396c-.63268 0-1.2181.375721-1.53884.987619z"
          className={s['outline']}
        />
        <path
          d="m7.37505 1c-.23085 0-.4429.12725-.5515.33095l-1.5377 2.88402-3.24082.50549c-.23888.03726-.43485.20895-.50319.44086l-.43978 1.49236c-.06315.21429-.00713.44599.14695.60774l2.35948 2.47707-.55267 3.47301c-.03761.2364.06301.4734.25913.6105l1.35113.9446c.20295.1418.47054.1505.68226.0221l2.65166-1.6086 2.6558 1.6111c.2096.1271.4742.12.6767-.0183l1.3704-.936c.2008-.1372.3038-.3783.2641-.6181l-.5755-3.48031 2.3556-2.47294c.1561-.16396.2114-.39958.1444-.61589l-.4563-1.47433c-.0706-.22802-.2649-.39592-.5008-.43271l-3.2467-.5064-1.51247-2.90023c-.1077-.2065-.32128-.33599-.55417-.33599z"
          className={s['filled']}
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </svg>
    )}
  </div>
);
EngagementIndicator.displayName = 'EngagementIndicator';

export default EngagementIndicator;
